import QTips from './QTips.vue';
import Vue from 'vue';

QTips.newInstance = properties => {
    const props = properties || {};

    const Instance = new Vue({
        data: props,
        render :h=> <QTips />
    });
	  // 手动mount
    const component = Instance.$mount();
    document.body.appendChild(component.$el);

    const notice = Instance.$children[0];

    return {
      open(infoProps) {
        notice.open(infoProps);
      },
      close() {
        notice.closeSelf();
      }
    }
};

export default QTips;



// WEBPACK FOOTER //
// ./src/components/QTips/src/main.js